import { Config } from "./contexts/ConfigurationContext";

export const configuration: Config = {
  corpusKey: "3",
  customerId: "2901857270",
  appTitle: "Chat UI",
  apiKey: "Bearer zwt_rPbT9mixSGC0vqJdQRZh7pZ7mEyFiqDHkuJh9g",
  endpoint: "https://api.vectara.io",
  questions: ["How do I structure my dream life?", "How do I know if a dream is worthy of me?"]
};
